import { Box, Chip } from '@mui/material';

const REASONS = [
  'Pád z kladiny',
  'Vynechání bariéry',
  'Nespojené spojky v cíli',
  'Cizí pomoc',
  'Nedokončení trati',
  'Falešný start',
  'Předčasné odpojení proudnice',
  'Použití cizího nářadí',
];

interface Props {
  onPick: (reason: string) => void;
}

export function NpReasonChips({ onPick }: Props) {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
      {REASONS.map((r) => (
        <Chip
          key={r}
          label={r}
          size="small"
          variant="outlined"
          onClick={() => onPick(r)}
          clickable
        />
      ))}
    </Box>
  );
}
